import { CatavoltAuth, Log, storage } from 'cv-dialog-sdk';
import { serviceFactory } from 'cv-react-core';

/* eslint-disable class-methods-use-this */
class OAuth {
    static CREATE_SESSION_TOKEN_PARAM_NAME = 'oauthToken';
    static PROOF_KEY = 'proofKey';

    /**
     * @returns {Promise<{ permissionToken, proofKey }>}
     */
    authenticate(tenantId) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async(resolve, reject) => {
            try {
                const proofKey = await serviceFactory.crypto.getSecureRandom(16);

                // Save the 'proofKey' in localStorage so that it will be used while making loginWithToken call
                storage.setItem(OAuth.PROOF_KEY, proofKey.toString('hex'));
                const initUrl = await CatavoltAuth.getOAuthUrl(tenantId, proofKey.toString('hex'), 'DESKTOP', window.location.href);

                this.openInCustomTab(initUrl);
                resolve();
            }
            catch (e) {
                Log.error(e);
                reject(e);
            }
        });
    }

    openInCustomTab(url) {
        return Promise.resolve(window.open(url, '_self'))
            .then((launched) => {
                Log.debug(`Launched custom tabs: ${launched}`);
            })
            .catch((err) => {
                Log.error(err);
            });
    }

    extractPermissionToken() {
        const params = new URLSearchParams(window.location.search);
        const oAuthtoken = params.get(OAuth.CREATE_SESSION_TOKEN_PARAM_NAME);
        return oAuthtoken;
    }
}

const oAuth = new OAuth();
export default oAuth;
export {
 OAuth,
};
